// For API
export const global_link =
  process.env.NODE_ENV === 'production'
    ? `${window.location.origin}/api/v1`
    : "http://localhost:5101";

// For Main WebSocket (presence, calls, queue, breaks)
export const socket_base_url =
  process.env.NODE_ENV === 'production'
    ? window.location.origin
    : "http://localhost:5100";

// For Audio WebSocket (listen-in, whisper)
export const audio_socket_base_url =
  process.env.NODE_ENV === 'production'
    ? window.location.origin
    : "http://localhost:5103";

// Paths for Socket.IO
export const socketiopath = '/socket.io';
export const audio_socket_path = '/audio-socket.io';
